import React from 'react'
import { Content, Heading, Typography, Anchor } from '@the-game/components'
import { contactMailToRef } from '@the-game/components/utils'
import { PageHelmet } from '../../meta/get-meta'

export function ContactAnchor({
    children,
}: {
    children: React.ReactNode
    sub?: string
}) {
    return <Anchor href={contactMailToRef()}>{children}</Anchor>
}

export function Contact() {
    return (
        <Content layout="column">
            <PageHelmet page="contact-us" />
            <Heading level="1">Contact us</Heading>
            <Typography variant="p">
                If you have a query you can contact us on{' '}
                <ContactAnchor>support@thegame.com.au</ContactAnchor>
            </Typography>
            <Typography>
                Once it has been handballed to us, we will take care of it
                between our bounce down at 9am and before the final siren at
                4.30pm, during game days of Monday to Friday.
            </Typography>
        </Content>
    )
}

export default Contact
